import React, { useState } from 'react';
import styled from 'styled-components';
import { PlanItem } from '../../../pay/paymentPlan';
import BottomModal from '../../modal/BottomModal';

interface Props {
  select: PlanItem;
  setSelect: (select: PlanItem) => void;
  plans: PlanItem[];
  onClose: () => void;
}

function RegionSelectModal({ select, setSelect, plans, onClose }: Props) {
  const [selectedPlan, setSelectedPlan] = useState(select);

  const isSame = (item: PlanItem) => {
    return (
      selectedPlan.plan_id === item.plan_id &&
      selectedPlan.plan_prc === item.plan_prc
    );
  };

  const disableItem = (plan: PlanItem) =>
    plan.plan_name === '전국' && plan.is_discount !== 'Y';
  return (
    <BottomModal onClose={onClose}>
      <Header>
        <Spacer />
        <Title>지역 선택</Title>
        <img
          src="/assets/images/close/close-dark-gray.svg"
          alt="닫기"
          width={24}
          onClick={onClose}
        />
      </Header>
      <Content>
        {[
          ...plans.filter(
            (p) => p.plan_name === '전국' && p.is_discount === 'N',
          ),
          ...plans.filter(
            (p) => p.plan_name === '전국' && p.is_discount === 'Y',
          ),
          ...plans.filter((p) => p.plan_name !== '전국'),
        ].map((item) => {
          const displayName =
            item.plan_name === '전국'
              ? item.is_discount === 'Y'
                ? '전국 특별할인'
                : '전국 정상가'
              : item.plan_name.split('(')[0];

          return (
            <Item
              $disable={disableItem(item)}
              $active={isSame(item)}
              onClick={() => {
                if (disableItem(item)) return;
                setSelectedPlan(item);
              }}
            >
              <img
                src={`/assets/images/check/check-${isSame(item) ? 'purple-small' : disableItem(item) ? 'disable' : 'gray'}.svg`}
                alt="check"
              />
              <RegionName>{displayName}</RegionName>
              <Price $disable={disableItem(item)}>
                {item.plan_prc.toLocaleString()}원
              </Price>
            </Item>
          );
        })}
      </Content>
      <ButtonContainer>
        <CancleButton onClick={onClose}>취소</CancleButton>
        <ConfirmButton
          onClick={() => {
            setSelect(selectedPlan);
            onClose();
          }}
        >
          적용
        </ConfirmButton>
      </ButtonContainer>
    </BottomModal>
  );
}

export default RegionSelectModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ModalContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px -4px 15px 0px #00000040;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  max-height: 640px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  height: 56px;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const Spacer = styled.div`
  width: 24px;
`;

const Title = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const Content = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  overflow-y: auto;
`;

const Item = styled.div<{ $disable?: boolean; $active?: boolean }>`
  display: flex;
  padding: 12px 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  color: ${({ $disable, $active }) =>
    $disable ? '#37383C9C' : $active ? '#4228D6' : '#222'};
`;

const RegionName = styled.div`
  flex: 1 0 0;
  font-size: 15px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.3px;
`;
const Price = styled.div<{ $disable?: boolean }>`
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.3px;

  ${({ $disable }) => $disable && 'text-decoration-line: line-through;'}
`;

const ButtonContainer = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-top: 1px solid rgba(112, 115, 124, 0.22);
`;

const Button = styled.div`
  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const CancleButton = styled(Button)`
  color: #616161;
  background: rgba(112, 115, 124, 0.08);
`;

const ConfirmButton = styled(Button)`
  flex: 1 0 0;
  color: #fff;
  background: #4228d6;
  font-weight: 700;
`;
